import cx from 'classnames';
import PropTypes from 'prop-types';
import { useState } from 'react';
import { useIsGlobetrotter } from '@bwoty-web/ui-kit/hooks';
import { ArrowLink, Button, GridBleed, Modal, Icon } from '@bwoty-web/ui-kit';
import { ICON_UI_CIRCLE_INFO } from '@bwoty-web/ui-kit/icons';

import './priceSummary.scss';

const PriceSummary = ({
  disclaimer = null,
  discounted = false,
  labels,
  loading = false,
  onNavigate,
  priceDetails = null,
  productAndPaxInfo = null,
  totalPrice,
}) => {
  const [showPriceDetails, setShowPriceDetails] = useState(false);
  const isGlobetrotter = useIsGlobetrotter();
  const WrapperElement = isGlobetrotter ? GridBleed : 'div';

  return (
    <WrapperElement
      className="iw-price-summary uikit-box"
      id="price-summary"
    >
      <div className="iw-price-summary__top">
        <div className="iw-price-summary__header">
          <span className="iw-price-summary__price-label">{labels.totalPrice}</span>
          <span
            className={cx('iw-price-summary__price', {
              'iw-price-summary__price--discounted': discounted,
            })}
          >
            {totalPrice}
          </span>
        </div>
        {productAndPaxInfo && <div className="iw-price-summary__products-included">{productAndPaxInfo}</div>}
        <Button
          variant="primary"
          className="iw-price-summary__button"
          loading={loading}
          disabled={loading}
          onClick={() => onNavigate()}
        >
          {labels.button}
        </Button>
        {labels.couponInfo && (
          <p className="iw-price-summary__coupon-info">
            <Icon
              path={ICON_UI_CIRCLE_INFO}
              className="iw-price-summary__coupon-info-icon"
              size="xs"
            />
            {labels.couponInfo}
          </p>
        )}
        {priceDetails && labels.priceDetails && (
          <div className="iw-price-summary__expand-price-container">
            <ArrowLink
              aria-haspopup="dialog"
              data-gtm-tag="Price Details"
              onClick={() => setShowPriceDetails(true)}
            >
              {labels.priceDetails}
            </ArrowLink>
          </div>
        )}
      </div>
      <Modal
        heading={labels.priceDetails}
        isOpen={priceDetails && showPriceDetails}
        onClose={() => setShowPriceDetails(false)}
        size="s"
      >
        <div className="iw-price-summary__price-details-container">{priceDetails}</div>
      </Modal>
      {disclaimer && (
        <div
          className={cx('iw-price-summary__disclaimer', {
            'iw-price-summary__disclaimer--no-margin': showPriceDetails,
          })}
        >
          {disclaimer}
        </div>
      )}
    </WrapperElement>
  );
};

PriceSummary.propTypes = {
  disclaimer: PropTypes.string,
  discounted: PropTypes.bool,
  labels: PropTypes.shape({
    button: PropTypes.string,
    priceDetails: PropTypes.string,
    totalPrice: PropTypes.string,
    couponInfo: PropTypes.string,
  }).isRequired,
  loading: PropTypes.bool,
  onNavigate: PropTypes.func.isRequired,
  priceDetails: PropTypes.node,
  productAndPaxInfo: PropTypes.string,
  totalPrice: PropTypes.string.isRequired,
};

export default PriceSummary;
